import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Link from 'components/shared/Link'
import { NotFoundWrapper } from './styles'
import decor from 'assets/images/notFound/notFound404_decor.svg'
import { FormattedMessage } from 'react-intl'
import { CONTACT_LINK, HOME_LINK } from 'constants/links'

const NotFound = () => (
    <NotFoundWrapper pt={[48, 56]} isFullWidth>
        <Box>
            <img src={decor} alt="404 decor" />
            <Box gap={24} mb={48} mt={[32, 40]}>
                <Text variant="heading1" color="grayscale_900">
                    <FormattedMessage
                        id="global.not_found.header"
                        defaultMessage="Nie znaleziono strony"
                    />
                </Text>
                <Text variant="bodyLarge" color="grayscale_700">
                    <FormattedMessage
                        id="global.not_found.body_text"
                        defaultMessage="Przepłynęliśmy nasz park wzdłuż i wszerz, ale nie znaleźliśmy strony, której szukasz. Być może ją usunęliśmy, wpisany adres jest nieaktualny lub zawiera błąd."
                    />
                </Text>
            </Box>
            <Box direction={['column', 'row']} gap={[24, 62]}>
                <Link
                    path={HOME_LINK}
                    variant="secondary"
                    icon="arrow"
                    iconColor="primary_500"
                    data-testid="page-404-redirect-homepage"
                >
                    <FormattedMessage
                        id="global.btn.back_to_homepage"
                        defaultMessage="Wróć do strony głównej"
                    />
                </Link>
                <Link
                    path={CONTACT_LINK}
                    variant="secondary"
                    icon="arrow"
                    iconColor="primary_500"
                    data-testid="page-404-redirect-contact"
                >
                    <FormattedMessage
                        id="global.btn.contact_us"
                        defaultMessage="Skontaktuj się z nami"
                    />
                </Link>
            </Box>
        </Box>
    </NotFoundWrapper>
)

export default NotFound
